module.exports = __webpack_public_path__ + "assets/img/smartTV-module1-1.407bb32b.jpg";